import "core-js/modules/es.array.push.js";
import { getRetailerToken } from "@faire/help-center-utils/serialized-data/getRetailer";
import { StringContextType } from "@faire/web-api/faire/translator/StringContextType";
import { path as getSelfServeRecommendedArticleRoute } from "@faire/web-api/routes/support/self-serve/recommended-article";
import { useHistory } from "react-router-dom";
import { FaireDirectDiscountsDataFn } from "../instantAnswerDataFunctions/faireDirectDiscountsDataFn";
import { ShippingContextDataFn } from "../instantAnswerDataFunctions/shippingContextDataFn";
import { ShouldDisplayMessageCTADataFn } from "../instantAnswerDataFunctions/shouldDisplayMessageCTADataFn";
export var NEED_MORE_INFO = function NEED_MORE_INFO(strictLocalize) {
  return strictLocalize({
    id: "I/a68g",
    defaultMessage: [{
      "type": 0,
      "value": "Il est possible que nous ayons besoin de plus d'informations pour vous aider à résoudre ce problème"
    }]
  });
};
var isBrand = function isBrand() {
  var retailerToken = getRetailerToken();
  if (retailerToken) {
    return false;
  }
  return true;
};
var GENERAL_MESSAGE_RETAILER_OR_BRAND = function GENERAL_MESSAGE_RETAILER_OR_BRAND(strictLocalize) {
  if (isBrand()) {
    return strictLocalize({
      id: "lDcUNv",
      defaultMessage: [{
        "type": 0,
        "value": "Pour résoudre le problème rapidement, contactez d'abord le client."
      }]
    });
  }
  return strictLocalize({
    id: "jXjtIm",
    defaultMessage: [{
      "type": 0,
      "value": "Pour résoudre le problème rapidement, contactez d'abord la marque."
    }]
  });
};
var GENERAL_MESSAGE_RETAILER_OR_BRAND_BUTTON = function GENERAL_MESSAGE_RETAILER_OR_BRAND_BUTTON(history, strictLocalize) {
  if (isBrand()) {
    return {
      label: strictLocalize({
        id: "J31qiB",
        defaultMessage: "Message the retailer"
      }),
      onClick: function onClick() {
        return messageRetailerOrBrandOnClick(history);
      }
    };
  }
  return {
    label: strictLocalize({
      id: "RQw6mA",
      defaultMessage: "Message the brand"
    }),
    onClick: function onClick() {
      return messageRetailerOrBrandOnClick(history);
    }
  };
};
var GENERAL_MESSAGE_DESCRIPTION_RETAILER_OR_BRAND = function GENERAL_MESSAGE_DESCRIPTION_RETAILER_OR_BRAND(strictLocalize) {
  if (isBrand()) {
    return strictLocalize({
      id: "O2+rZ+",
      defaultMessage: [{
        "type": 0,
        "value": "Le plus souvent, ce type de problème peut être résolu en contactant le client. S'il ne peut pas vous aider, n'hésitez pas à nous contacter à nouveau."
      }]
    });
  }
  return strictLocalize({
    id: "Pwzacl",
    defaultMessage: [{
      "type": 0,
      "value": "Le plus souvent, ce type de problème peut être résolu en contactant la marque. Si celle-ci ne peut pas vous aider, n'hésitez pas à nous contacter à nouveau."
    }]
  });
};
export var SELF_SERVE_GENERAL_DESCRIPTION_WITH_CONTEXT = function SELF_SERVE_GENERAL_DESCRIPTION_WITH_CONTEXT(strictLocalize, context) {
  if (context.brandOrder) {
    return isBrand() ? strictLocalize({
      id: "O2+rZ+",
      defaultMessage: [{
        "type": 0,
        "value": "Le plus souvent, ce type de problème peut être résolu en contactant le client. S'il ne peut pas vous aider, n'hésitez pas à nous contacter à nouveau."
      }]
    }) : strictLocalize({
      id: "Pwzacl",
      defaultMessage: [{
        "type": 0,
        "value": "Le plus souvent, ce type de problème peut être résolu en contactant la marque. Si celle-ci ne peut pas vous aider, n'hésitez pas à nous contacter à nouveau."
      }]
    });
  }
  return GENERAL_MESSAGE_DESCRIPTION_RETAILER_OR_BRAND(strictLocalize);
};
export var SELF_SERVE_GENERAL_TITLE_WITH_CONTEXT = function SELF_SERVE_GENERAL_TITLE_WITH_CONTEXT(strictLocalize, context) {
  if (context.brandOrder) {
    var selectedBrandOrder = context.brandOrder;
    var brandName = selectedBrandOrder === null || selectedBrandOrder === void 0 ? void 0 : selectedBrandOrder.brand_name;
    var retailerName = selectedBrandOrder === null || selectedBrandOrder === void 0 ? void 0 : selectedBrandOrder.retailer_name;
    var conversationName = isBrand() ? retailerName : brandName;
    if (!conversationName) {
      return GENERAL_MESSAGE_RETAILER_OR_BRAND(strictLocalize);
    }
    return strictLocalize({
      id: "cFFGWB",
      defaultMessage: [{
        "type": 0,
        "value": "Pour résoudre le problème rapidement, contactez d'abord "
      }, {
        "type": 1,
        "value": "conversationCompanyName"
      }, {
        "type": 0,
        "value": "."
      }]
    }, {
      conversationCompanyName: conversationName
    });
  }
  return GENERAL_MESSAGE_RETAILER_OR_BRAND(strictLocalize);
};
export var MessageRetailerOrBrandButton = function MessageRetailerOrBrandButton(context, strictLocalize) {
  var history = useHistory();
  var brandOrder = context.brandOrder;
  if (!brandOrder || !context.shouldDisplayCTAOfContactBrandOrRetailer) {
    return undefined;
  }
  var selectedBrandOrder = context.brandOrder;
  var brandName = selectedBrandOrder === null || selectedBrandOrder === void 0 ? void 0 : selectedBrandOrder.brand_name;
  var retailerName = selectedBrandOrder === null || selectedBrandOrder === void 0 ? void 0 : selectedBrandOrder.retailer_name;
  var conversationName = isBrand() ? retailerName : brandName;
  if (!conversationName) {
    return GENERAL_MESSAGE_RETAILER_OR_BRAND_BUTTON(history, strictLocalize);
  }
  return {
    label: strictLocalize({
      id: "07TJUq",
      defaultMessage: "Message {conversationCompanyName}"
    }, {
      conversationCompanyName: conversationName
    }),
    onClick: function onClick() {
      return messageRetailerOrBrandOnClick(history);
    }
  };
};
var messageRetailerOrBrandOnClick = function messageRetailerOrBrandOnClick(history) {
  if (history) {
    history.push(getSelfServeRecommendedArticleRoute({
      message_modal: "1"
    }));
  }
};
export var additionalDataRequiredForContactingRetailerOrBrandCTA = function additionalDataRequiredForContactingRetailerOrBrandCTA() {
  return [ShippingContextDataFn, ShouldDisplayMessageCTADataFn];
};
export var additionalDataRequiredForFaireDiscountsSignUpOfferIA = function additionalDataRequiredForFaireDiscountsSignUpOfferIA() {
  return [FaireDirectDiscountsDataFn];
};